import SliderCard from './SliderCard';

export default SliderCard;
